import { takeLatest, put, call, select } from 'redux-saga/effects';
import { UPDATE_PROMO_SAGA } from "../sagaTypes";
import { loaderAction, promoFormAction } from "../rootReducer";
import { url } from "../../config";
import growl from "../../lib/growl/growl";
import { setLocalStorage } from "../../helpers/LocalStorage";
import { getPromoSagaAction } from "../sagaActions";
import { PROMO_FORM_INITIAL } from "../initialStateConstant";

const request = data => {
    return fetch(`${ url }/update_promo`, {
        method: 'post',
        body: data
    })
        .then(response => response.json()).catch(error => console.log(error))
};

function* workerUpdatePromo(args) {
    const user = yield select(state => state.user);
    yield put(loaderAction(true));
    try {
        let formData = new FormData();
        formData.append('user_id', user.id);
        formData.append('hash', user.hash);

        formData.append('promo_id', args.data.id);
        formData.append('name', args.data.name);
        formData.append('description', args.data.description);
        formData.append('code', args.data.code);
        formData.append('discount', args.data.discount);
        formData.append('image', args.data.image?.file || args.data.image);
        formData.append('active', args.data.active);
        formData.append('establishments', args.data.establishments);
        formData.append('news', args.data.news);
        formData.append('expire', args.data.expire);
        formData.append('link', args.data.link);

        const response = yield call (request, formData);

        // Если не прошли проверку хеша разлогиниваемся
        if (response.void) {
            setLocalStorage('afp_fitness', '').then(() => window.location.reload());
        }

        if (response.success) {
            // Обновляем список акций
            yield put(getPromoSagaAction());
            // Очищаем форму акции
            yield put(promoFormAction(PROMO_FORM_INITIAL));
            growl({ type: 'success', message: response.message });
        }
        else if (response.error) {
            growl({ type: 'error', message: response.message });
        }
    }
    catch(error) {
        console.log(error);
        yield put(loaderAction(false));
    }
    finally {
        yield put(loaderAction(false));
    }
}

export default function* watcherUpdatePromo() {
    yield takeLatest(UPDATE_PROMO_SAGA, workerUpdatePromo);
}